<div class="step-page" id="data-management">
	<div class="step-title">
		<div class="header-title">Data Management</div>
	</div>
	<div class="step-content">
		<!-- <div class="row-left" *ngIf="isAdmin||customerType==='integrator'">
			<div>Agency</div>
			<app-feature-available-agencies [agencyType]="customerType" [selectedAgencyId]="selectedCustomerId" (changeAgency)="onChangeCustomer($event)"></app-feature-available-agencies>
		</div> -->
		<div class="button-wrap">
			<div class="layer-title">Filter by layer type :</div>
			<div Class="buttons">
				<button (click)="deleteLayers()" [disabled]="isDelete !== true" class="button-general">Delete</button>
				<button (click)="purgeLayer()" [disabled]="isPurge !== true" class="button-general">Purge</button>
			</div>
		</div>
		<div class="dataset-panel">
			<div class="layer-wrap">
				<select class="layer-panel" [size]="layers?.length" (change)="getLayerHistory()" [(ngModel)]="layerTypeId">
					<option [ngValue]="null">All</option>
					<option *ngFor="let layer of layers" [ngValue]="layer.glt_id">{{layer.glt_cd}}</option>
				</select>
			</div>
			<div class="history-wrap">
				<div class="table">
				<!-- <ngx-datatable 
				class="material"
				[rows]="layerHistories"
				[columns]="columns"
				(select)="onSelect($event)">
				</ngx-datatable> -->
				<app-common-datagrid
					#layerHistoriesTable
					[rows]="layerHistories"
					[columns]="columns"
					[selectionType]="undefined"
					[isPaging]="false"
					[totalNum]="layerHistories.length">
				</app-common-datagrid>
				</div>
			</div>
		</div>
	</div>
</div>
<ng-template #checkbox let-row="row" let-column="column" ngx-datatable-cell-template>
	<input type="checkbox" [(ngModel)]="row[column.prop]" (change)="toggleCheckBox($event, row)">
</ng-template>
<ng-template #headerTempl let-column="column" ngx-datatable-header-template>
	<input type="checkbox" (change)="selectAll($event)">
</ng-template>
<ng-template #deleteStatus let-row="row" ngx-datatable-cell-template>
	<i *ngIf="row.gly_deleted === true" class="glyphicons glyphicons-remove" style="color:red" title="Deleted"></i>
	<i *ngIf="row.gly_deleted === false" class="glyphicons glyphicons-tick" style="color:green" title="Active"></i>
</ng-template>
	
	
	